import {i18n} from 'i18n';
import {IDropdownOption} from 'typings';

export const OrderingCatalogOptions: IDropdownOption[] = [
    {value: 'date', text: i18n.t('Date (newest first)')},
    {value: '-date', text: i18n.t('Date (oldest first)')},
    {value: 'cashback_size', text: i18n.t('Percent (lowest first)')},
    {value: '-cashback_size', text: i18n.t('Percent (highest first)')},
];
